import * as React from "react";
const SvgArrowDown20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 9,
        fill: "black",
        viewBox: "0 0 14 9"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m2 .586 5 5 5-5L13.414 2 7 8.414.586 2 2 .586Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowDown20Px;
